// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"204":"fa037d24","255":"47725770"}[chunkId] + ".css";
};